export default [

    {
        name: 'zlAllCase',
        path: 'zlAllCase',
        component: () => import('@/pages/BigData/PatentModule/ApplicationCase/zlAllCase'),
        meta: { title: '全部', requiresAuth: true },
        props(route) {
            return {id: route.query.id}
        }
    },
    {
        name: 'zlwaitReporting',
        path: 'zlwaitReporting',
        component: () => import('@/pages/BigData/PatentModule/ApplicationCase/zlwaitReporting'),
        meta: { title: '待申报', requiresAuth: true },
        props(route) {
            return {id: route.query.id}
        }
    },
    {
        name: 'zlDeclareing',
        path: 'zlDeclareing',
        component: () => import('@/pages/BigData/PatentModule/ApplicationCase/zlDeclareing'),
        meta: { title: '申报中', requiresAuth: true },
        props(route) {
            return {id: route.query.id}
        }
    },
    {
        name: 'zlReviewing',
        path: 'zlReviewing',
        component: () => import('@/pages/BigData/PatentModule/ApplicationCase/zlReviewing'),
        meta: { title: '已申报审查中', requiresAuth: true },
        props(route) {
            return {id: route.query.id}
        }
    },
    {
        name: 'zlReviewopinions',
        path: 'zlReviewopinions',
        component: () => import('@/pages/BigData/PatentModule/ApplicationCase/zlReviewopinions'),
        meta: { title: '审查意见', requiresAuth: true },
        props(route) {
            return {id: route.query.id}
        }
    },
    {
        name: 'zlAuthorized',
        path: 'zlAuthorized',
        component: () => import('@/pages/BigData/PatentModule/ApplicationCase/zlAuthorized'),
        meta: { title: '已授权', requiresAuth: true },
        props(route) {
            return {id: route.query.id}
        }
    },
    {
        name: 'zlAuthorizedfee',
        path: 'zlAuthorizedfee',
        component: () => import('@/pages/BigData/PatentModule/ApplicationCase/zlAuthorizedfee'),
        meta: { title: '已缴授权', requiresAuth: true },
        props(route) {
            return {id: route.query.id}
        }
    },
    {
        name: 'zlVerified',
        path: 'zlVerified',
        component: () => import('@/pages/BigData/PatentModule/ApplicationCase/zlVerified'),
        meta: { title: '已下证', requiresAuth: true },
        props(route) {
            return {id: route.query.id}
        }
    },
    {
        name: 'zlcancel',
        path: 'zlcancel',
        component: () => import('@/pages/BigData/PatentModule/ApplicationCase/zlcancel'),
        meta: { title: '已作废', requiresAuth: true },
        props(route) {
            return {id: route.query.id}
        }
    },
    {
        name: 'CaseDetails',
        path: 'CaseDetails',
        redirect: { name: 'shenqingren' }, // 重定向到指定名称的路由,
        component: () => import('@/pages/BigData/PatentModule/CaseDetails/index'),
        meta: { title: '案件详情' },
        props(route) {
            return {id: route.query.id}
        },
        children: [
            {
                name: 'shenqingren',
                path: 'shenqingren',
                component: () => import('@/pages/BigData/PatentModule/CaseDetails/shenqingren'),
                meta: { title: '申报材料' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
            {
                name: 'famingren',
                path: 'famingren',
                component: () => import('@/pages/BigData/PatentModule/CaseDetails/famingren'),
                meta: { title: '发明人材料' },
                props(route) {
                    return {
                        id: route.query.id,

                    }
                },
            },
            {
                name: 'shitu',
                path: 'shitu',
                component: () => import('@/pages/BigData/PatentModule/CaseDetails/shitu'),
                meta: { title: '视图材料' },
                props(route) {
                    return {
                        id: route.query.id,

                    }
                },
            },
            {
                name: 'wenan',
                path: 'wenan',
                component: () => import('@/pages/BigData/PatentModule/CaseDetails/wenan'),
                meta: { title: '文案材料' },
                props(route) {
                    return {
                        id: route.query.id,

                    }
                },
            },
            {
                name: 'CPCanjian',
                path: 'CPCanjian',
                component: () => import('@/pages/BigData/PatentModule/CaseDetails/CPCanjian'),
                meta: { title: 'CPC材料' },
                props(route) {
                    return {
                        id: route.query.id,

                    }
                },
            },
            {
                name: 'NeedConfirm',
                path: 'NeedConfirm',
                component: () => import('@/pages/BigData/PatentModule/CaseDetails/NeedConfirm'),
                meta: { title: '需确认材料' },
                props(route) {
                    return {
                        id: route.query.id,

                    }
                },
            },
            {
                name: 'notedocmt',
                path: 'notedocmt',
                component: () => import('@/pages/BigData/PatentModule/CaseDetails/notedocmt'),
                meta: { title: '通知文书' },
                props(route) {
                    return {
                        id: route.query.id,

                    }
                },
            },
        ]
    },
]